import { fetchAIFlags } from './ai-flags.utils';
import isEmpty from 'lodash/isEmpty';
import keyBy from 'lodash/keyBy';

export default {
    namespaced: true,
    state: {
        map: {},
        error: {},
        fetching: false,
    },
    mutations: {
        setMap (state, { map }) {
            state.map = map;
        },
        setError (state, { error }) {
            state.error = error;
        },
        setFetching (state, { fetching }) {
            state.fetching = fetching;
        },
    },
    actions: {
        async hydrate ({ dispatch, commit }, { aiSettings } = {}) {
            if (!aiSettings) {
                await dispatch('loadAll', { reFetch: true });

                return;
            }

            commit('setMap', { map: keyBy(aiSettings, 'flag') });
        },
        async loadAll ({ commit, state }, { reFetch = false, subscriptionId, isSuperSettings = false } = {}) {
            if (!isEmpty(state.map) && !reFetch) {
                return;
            }

            commit('setFetching', { fetching: true });
            try {
                const aiSettings = await fetchAIFlags(subscriptionId, isSuperSettings);
                commit('setFetching', { fetching: false });
                commit('setMap', { map: keyBy(aiSettings, 'flag') });
            } catch (error) {
                commit('setFetching', { fetching: false });
                commit('setError', { error });
                // Don't explode
            }
        },
    },
    getters: {
        aiFlagsMap: (state) => state.map,
        canEnableAIFlag: (state) => (name) => {
            const flag = state.map?.[name];

            return flag ? flag.canEnable : false;
        },
    },
};
